import { ButtonV2, Flex, TextV2 } from '@withjoy/joykit';
import React, { ReactNode } from 'react';
import { SpamQueueRow } from '../../types';
import { SpamRowContainer } from './SpamRow.styles';
import { Username } from '../Username';
import { extractMessageField } from '../../utils/extractMessageField';

export type SpamRowProps = {
  data: SpamQueueRow;
  onClick: (row: SpamQueueRow) => void;
};

const relativeTime = new Intl.RelativeTimeFormat('en', { style: 'short' });
const toRelativeTime = (date: string): string => {
  const then = new Date(date).getTime();

  if (!then) {
    return '';
  }

  const now = Date.now();
  const timeAgo = (then - now) / 1000 / 60 / 60;
  return relativeTime.format(timeAgo, 'hours');
};

export const SpamRow = (props: SpamRowProps) => {
  return <MessageRow {...props} />;
};

const MessageRow = (props: SpamRowProps) => {
  const { data } = props;

  if (typeof data.messageBatchPayload === 'object') {
    const subject = extractMessageField(data.messageBatchPayload, 'subject');
    const summary = extractMessageField(data.spamIndicatorsPayload, 'summary');
    const messages = extractMessageField(data.messageBatchPayload, 'messages');

    const msgCount = Array.isArray(messages) ? messages.length : 1;

    return (
      <BasicMessageRow {...props}>
        <Flex justifyContent="space-between">
          <Flex
            flexDirection="column"
            gap="0.5rem"
          >
            <TextV2>{subject}</TextV2>
            <TextV2>{summary}</TextV2>
            <TextV2>
              {msgCount} message{msgCount !== 1 ? 's' : ''}
            </TextV2>
          </Flex>
          <Flex gap="1rem">
            <ButtonV2>Review</ButtonV2>
          </Flex>
        </Flex>
      </BasicMessageRow>
    );
  }

  return (
    <BasicMessageRow {...props}>
      <TextV2>{props.data.messageBatchPayload.toString()}</TextV2>
    </BasicMessageRow>
  );
};

const BasicMessageRow = (props: SpamRowProps & { children?: ReactNode }) => {
  const { data, onClick, children } = props;

  const reviewedAtDate = data.reviewedAt ? new Date(data.reviewedAt) : null;

  return (
    <SpamRowContainer
      onClick={() => {
        onClick(data);
      }}
    >
      {data.reviewedAt && data.reviewedByUserId && (
        <Flex
          flexDirection="column"
          gap="0.25rem"
        >
          <TextV2 typographyVariant={['hed1', 'hed2']}>
            Reviewed by <Username id={data.reviewedByUserId} />
          </TextV2>
        </Flex>
      )}
      <Flex
        flexDirection="column"
        gap="0.5rem"
      >
        {data.reviewedAt && reviewedAtDate && (
          <TextV2 typographyVariant="hed1">
            Message reviewed {reviewedAtDate.toLocaleDateString} {reviewedAtDate.toLocaleString()}
          </TextV2>
        )}
        <TextV2 typographyVariant="hed1">Message sent {toRelativeTime(data.createdAt)}</TextV2>
        {children}
      </Flex>
    </SpamRowContainer>
  );
};
